/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Walkthrough_Attachment_DescriptionInputs */

const es_walkthrough_attachment_description = /** @type {(inputs: Walkthrough_Attachment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adjuntá archivos a tus mensajes. También podés arrastrar y soltar archivos o pegarlos directamente.`)
};

const en_walkthrough_attachment_description = /** @type {(inputs: Walkthrough_Attachment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attach files to your messages. You can also drag and drop files or paste them directly.`)
};

/**
* | output |
* | --- |
* | "Attach files to your messages. You can also drag and drop files or paste them directly." |
*
* @param {Walkthrough_Attachment_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const walkthrough_attachment_description = /** @type {((inputs?: Walkthrough_Attachment_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Walkthrough_Attachment_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_walkthrough_attachment_description(inputs)
	return en_walkthrough_attachment_description(inputs)
});
export { walkthrough_attachment_description as "walkthrough.attachment_description" }